import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AppLogo from './AppLogo';
import Config from 'app/common/js/utils/Config';
import { Select } from '@veneer/core';
import withReducer from 'app/common/js/utils/WithReducer';
import { setLanguage, languageReducer } from 'app/api/actions/languageSlice';

import '../../styles/common/AppHeader.scss';

const AppHeader = () => {
  const dispatch = useDispatch();
  const languageList = Config.languageOptions(true);

  // Get language from Redux store (with fallback if reducer not yet loaded)
  const selectedLanguage = useSelector((state) =>
    state.language ? state.language.selectedLanguage : L10n.selectedLang || localStorage.getItem('language') || 'en',
  );

  const handleLanguageChange = (selectedOption) => {
    const languageCode = selectedOption.value;
    // Dispatch action to update Redux store (also syncs with localStorage)
    dispatch(setLanguage({ language: languageCode, updateLocalStorage: true }));
  };

  return (
    <header className='app-header bg-color app-header-bb'>
      <AppLogo />
      <Select
        id='lang'
        options={languageList}
        onChange={handleLanguageChange}
        className='lang-select'
        value={[selectedLanguage.replace(/-/g, '_')]}
        clearIcon={false}
      />
    </header>
  );
};

// Inject language reducer dynamically
export default withReducer({
  [languageReducer.name]: languageReducer.reducer,
})(AppHeader);
